import { atom } from 'recoil';

const newNotificationAtom = atom<boolean>({
  key: 'newNotificationAtom',
  default: false,
});

export default newNotificationAtom;
